import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { authSelectors } from 'store/selectors/auth';
import { organizationSelectors } from 'store/selectors/organizations';
import { clearOrganization, identifyUser, setOrganization } from 'utils/analytics';

const Analytics = ({ organizationUuid }) => {
  const user = useSelector(authSelectors.getUser);
  const organization = useSelector(organizationSelectors.getOrganization);

  useEffect(() => {
    if (user.uuid) {
      identifyUser(user.uuid, {
        email: user.email,
        name: `${user.firstName} ${user.lastName}`,
      });
    }
  }, [user.email, user.firstName, user.lastName, user.uuid]);

  useEffect(() => {
    if (!organizationUuid) {
      clearOrganization();

      return;
    }

    // Only associate the organization once the fetched data matches the
    // URL, so events are never tagged with a stale organization while a
    // newly navigated-to organization is still loading.
    if (organization.uuid === organizationUuid) {
      setOrganization(organization.uuid, { name: organization.name });
    }
  }, [organization.name, organization.uuid, organizationUuid]);

  return null;
};

Analytics.propTypes = {
  organizationUuid: PropTypes.string,
};

Analytics.defaultProps = {
  organizationUuid: null,
};

export default Analytics;
